import { render, staticRenderFns } from "./lawyer-card.vue?vue&type=template&id=426fada8&scoped=true&"
import script from "./lawyer-card.vue?vue&type=script&lang=js&"
export * from "./lawyer-card.vue?vue&type=script&lang=js&"
import style0 from "./lawyer-card.vue?vue&type=style&index=0&id=426fada8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426fada8",
  null
  
)

export default component.exports